export function formatPathname(...segments: Array<string | null | undefined>) {
  return `/${segments
    .filter((segment): segment is string => typeof segment === "string")
    .map((segment) => segment.replace(/^\/+|\/+$/g, ""))
    .filter(Boolean)
    .join("/")}`;
}
